<template>
  <div class="section-wrapper">
    <!-- <div class="breadcrumb-wrapper">
      <b-breadcrumb class="custom-bread"></b-breadcrumb>
    </div> -->
    <b-breadcrumb>
      <b-breadcrumb-item to="/dashboard">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        Dashboard
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/book-page">Manage Book</b-breadcrumb-item>
      <b-breadcrumb-item active>Book Cover Page</b-breadcrumb-item>
    </b-breadcrumb>
      <div class="form-wrapper">
      <b-card title="Book Cover Page Search">
          <b-card-text>
              <b-row style="font-size: 13px;">
                <b-col sm="12" md="3">
                  <b-form-group
                      id="edition"
                      label="Edition"
                      label-for="edition"
                  >
                      <b-form-input
                      id="edition"
                      v-model="search.edition"
                      type="text"
                      placeholder="Enter Edition"
                      required
                      ></b-form-input>
                  </b-form-group>
                </b-col>
              <b-col lg="3" md="3" sm="3" xs="6">
                <b-form-group
                 label-for="page_type"
                >
                <template v-slot:label>
                 Page Type
                </template>
                <b-form-select
                    plain
                    v-model="search.position"
                    :options="coverPositionList"
                    id="page_type"
                   >
                  <template v-slot:first>
                   <b-form-select-option :value=0>Select</b-form-select-option>
                 </template>
                </b-form-select>
              </b-form-group>
            </b-col>
                <b-col sm="12" md="3">
                  <br>
                  <b-button size="sm" variant="primary" @click="searchData"><i class="ri-search-line"></i> Search</b-button>
                  <b-button size="sm ml-1" variant="danger" @click="clearData"><i class="ri-close-line"></i> Clear</b-button>
                </b-col>
              </b-row>
          </b-card-text>
      </b-card>
  </div>
  <b-card class="mt-3">
      <b-card-title>
        <b-row>
          <b-col>
            <h4 class="card-title mb-0 pl-0">Book Cover Page List</h4>
          </b-col>
          <b-col class="text-right">
            <b-button v-if="has_permission('add_new_book_cover_page')" size="sm" variant="info" @click="openAddNewModal()">Add New<i class="ri-add-fill"></i></b-button>
          </b-col>
        </b-row>
      </b-card-title>
      <b-row>
        <b-col>
          <b-overlay :show="loading">
            <b-card>
              <div class="table-wrapper table-responsive mt-0">
                <table class="table table-striped table-hover table-bordered">
                  <thead>
                    <tr style="font-size: 13px;">
                      <th scope="col" class="text-center">SL</th>
                      <th scope="col" class="text-center">Position</th>
                      <th scope="col" class="text-center">Edition</th>
                      <th scope="col" class="text-center">Release Date</th>
                      <th scope="col" class="text-center">Cover photo</th>
                      <th scope="col" class="text-center">Active</th>
                      <th scope="col" class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in listData" :key="index">
                    <tr style="font-size: 12px;">
                      <td scope="row" class="text-center">{{ index + pagination.slOffset }}</td>
                      <td class="text-center">
                        <span v-if="item.position === 'frontpage'">Front Page</span>
                        <template v-else>Back Page</template>
                      </td>
                      <td class="text-center">
                        {{ item.edition }}
                      </td>
                      <td class="text-center">
                        {{ item.release_date ? dDate(item.release_date) : '' }}
                      </td>
                      <td class="text-center">
                        <img v-if="item.cover_photo" :src="item.cover_photo" class="mr-2" height="70" alt="Cover photo">
                      </td>
                      <td class="text-center">
                        <b-form-checkbox  v-if="has_permission('active_or_deactive_book_cover_page')" @change="toggleActiveStatus(item)" v-model="item.active" name="check-button" switch>
                        </b-form-checkbox>
                      </td>
                      <td class="text-center">
                        <button v-tooltip="'Content Details'" style="width: 20px !important; height: 19px !important; font-size:10px" href="javascript:" class="action-btn active" @click="detailsData(item)"><i class="ri-eye-fill"></i></button>
                        <a v-tooltip="'Edit'" v-if="has_permission('edit_book_cover_page')" style="width: 20px !important; height: 20px !important; font-size:10px" href="javascript:" class="action-btn edit" @click="editData(item)"><i class="ri-pencil-fill"></i></a>
                        <a v-tooltip="'Delete'" v-if="has_permission('delete_book_cover_page')" @click="deleteData(item)" style="width: 20px !important; height: 20px !important; font-size:10px" href="javascript:" class="action-btn delete"><i class="ri-delete-bin-2-line"></i></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card>
          </b-overlay>
        </b-col>
    </b-row>
  </b-card>
    <b-modal id="modal-2" ref="detailsModal" size="lg" title="Content Details" :hide-footer="true">
      <Details :editItem="editItem"/>
    </b-modal>
    <!-- pagination -->
    <div class="pagination-wrapper mt-4">
      <span>Showing {{ pagination.slOffset }} from {{ pagination.totalRows }} entries</span>
      <b-pagination
        size="sm"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total-rows="pagination.totalRows"
        @input="searchData"
        />
    </div>
  </div>
</template>

<script>
import Details from './Details.vue'
import RestApi, { apiBaseURL } from '@/config'

export default {
  components: {
    Details
  },

  data () {
    return {
      // pagination
      rows: 100,
      currentPage: 1,
      // form data
      search: {
        edition: '',
        position: 0
      },
      value: '',
      listData: [],
      loading: false,
      editItem: '',
      item: ''
    }
  },
  created () {
    this.getListData()
  },
  computed: {
    coverPositionList: function () {
      const list = [
        { value: 'frontpage', text: 'Front Page' },
        { value: 'backpage', text: 'Back Page' }
      ]
      return list
    }
  },
  methods: {
    openAddNewModal () {
      // this.editItem = ''
      // this.$refs.editModal.show()
      this.$router.push('/add-or-update-book-cover-page-content')
    },
    editData (item) {
      // this.editItem = item
      // this.$refs.editModal.show()
      this.$router.push(`/add-or-update-book-cover-page-content/${this.hash_id(item.id)}`)
    },
    detailsData (item) {
      this.editItem = item
      this.$refs.detailsModal.show()
    },
    searchData () {
      this.getListData()
    },
    clearData () {
      this.search = {
        page_no: '',
        page_type: 0
      }
      this.getListData()
    },
    async getListData () {
      this.loading = true
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      var result = await RestApi.getData(apiBaseURL, 'admin/ajax/get_book_cover_page_list', params)
      if (result.success) {
        this.listData = result.data.data
        this.paginationData(result.data)
      }
      this.loading = false
    },
    async toggleActiveStatus (item) {
      this.loading = true
      var result = await RestApi.postData(apiBaseURL, 'admin/ajax/toggle_book_cover_page_active_status', item)
      if (result.success) {
        this.$toast.success({ title: 'Success', message: result.message })
        this.getListData()
      }
      this.loading = false
    },
    deleteData (item) {
      this.$swal({
        title: 'Are you sure to delete?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteConfirmation(item)
        }
      })
    },
    async deleteConfirmation (item) {
      this.loading = true
      var result = await RestApi.postData(apiBaseURL, 'admin/ajax/delete_book_cover_page_data', item)
      if (result.success) {
        this.$toast.success({
          title: 'Success',
          message: result.message
        })
        this.getListData()
      }
      this.loading = false
    }
  }
}
</script>
<style scoped>
 .fontStyle {
  text-align: justify
 }
</style>
